module.exports = new __parcel__URL__("roundabout.f8c29998.jpg").toString();